import { Eyebrow, Reveal, Counter } from "./bits";

const pillars = [
  {
    slug: "personalised",
    n: "01",
    title: "Personalised",
    body: "Advice shaped around individual goals. Your life sets the strategy — never the other way around.",
    stat: { to: 100, suffix: "%", label: "of advice built around your goals" },
  },
  {
    slug: "transparent",
    n: "02",
    title: "Transparent",
    body: "Clear communication without unnecessary complexity. You always know what you own, and why.",
    stat: { to: 0, suffix: "", label: "jargon, hidden agendas, fine print" },
  },
  {
    slug: "goal-oriented",
    n: "03",
    title: "Goal-oriented",
    body: "Every investment decision should have a purpose. We start with the destination, then draw the map.",
    stat: { to: 6, suffix: "", label: "focused services, one philosophy" },
  },
  {
    slug: "long-term",
    n: "04",
    title: "Long-term",
    body: "Sustainable wealth creation over short-term noise. Patience isn't a compromise — it's the strategy.",
    stat: { to: 5, suffix: "", label: "life-goal frameworks we plan for" },
  },
];

export const WhyUs = () => (
  <section id="why" data-testid="why-section" className="relative py-28 md:py-40">
    <div className="mx-auto max-w-6xl px-6">
      <Reveal>
        <Eyebrow>07 — Why HRKAPITAL</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-6 max-w-3xl font-display text-4xl leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
          Built around people, <span className="italic text-emerald-600">not products.</span>
        </h2>
      </Reveal>

      <div className="mt-16">
        {pillars.map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.05}>
            <div
              data-testid={`why-pillar-${p.slug}`}
              className="grid items-center gap-6 border-t border-[#10202E]/10 py-10 md:grid-cols-[auto_1fr_auto] md:gap-12"
            >
              <span className="select-none font-display text-6xl leading-none text-[#10202E]/[0.06] md:text-7xl">
                {p.n}
              </span>
              <div className="max-w-xl">
                <h3 className="font-display text-3xl text-[#10202E]">{p.title}</h3>
                <p className="mt-3 text-base font-light leading-relaxed text-[#4E6A82]">{p.body}</p>
              </div>
              <div className="md:text-right">
                <Counter
                  to={p.stat.to}
                  suffix={p.stat.suffix}
                  className="font-display text-5xl text-emerald-600 md:text-6xl"
                />
                <p className="mt-2 max-w-[180px] font-mono text-[10px] uppercase leading-relaxed tracking-[0.18em] text-[#6E8698] md:ml-auto">
                  {p.stat.label}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-[#10202E]/10" />
      </div>
    </div>
  </section>
);
